module.exports = __webpack_public_path__ + "img/rtf.ec837aa2.svg";